import React, { useMemo } from 'react';
import { IStormDoorListing } from '../../../../entities-generated/models/storm-door/storm-door-listing';
import { BwjListing } from '../../../../framework/components/bwj-listing';
import { DoorSize } from '../../../../entities-generated/common/door-size';
import { BadgeType } from '../../../../framework/components/bwj-listing/entities';
import { toDateTimeString } from '../../../../framework/utils/date-time';

interface IStormDoorListItemProps {
  door: IStormDoorListing;
  onClick: (door: IStormDoorListing) => void;
}

export const StormDoorListItem: React.FunctionComponent<IStormDoorListItemProps> = (props) => {
  const { door } = props;
  const heading = useMemo(() => {
    const dims = DoorSize[door.doorSize].split('_')[1].replace('x', ' x ');
    return dims;
  }, [door]);
  const state = useMemo(() => {
    if(door.inactive) { return '[Inactive] '; }
    if(door.unavailable) { return '[Unavailable] '; }
    return '';
  }, [door]);
  const subtext = useMemo(() => {
    const st: string[] = [`@ ${door.vendor}`];
    if(!!door.lastModified) {
      st.push(`last modified ${toDateTimeString(door.lastModified)}`);
    }
    return st.join('; ');
  }, [door]);

  return (
    <BwjListing
      heading={heading}
      badge={{
        type: BadgeType.Image,
        content: door.imageUrl,
      }}
      loadImage={true}
      secondaryLine={`${state}${door.brand} ${door.description}`}
      footnote={subtext}
      data={door}
      onClick={props.onClick}
    />
  );
};
